// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rte h2{font-size:32px;text-transform:uppercase;--tw-text-opacity:1;color:rgba(47,83,176,var(--tw-text-opacity));font-weight:700;line-height:1;margin-bottom:30px}.rte a{-webkit-text-decoration:underline;text-decoration:underline}@media (min-width:48em){.rte h2{font-size:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
